"use strict";

import { c as _c } from "react/compiler-runtime";
import { Box, Icon, Inline, Text, useTextStyles } from '@autoguru/overdrive';
import { memo } from 'react';
import * as styles from './UserMenuOption.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const UserMenuOption = /*#__PURE__*/memo(t0 => {
  const $ = _c(12);
  const {
    label,
    icon,
    onClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      colour: "dark"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const colourCls = useTextStyles(t1);
  let t2;
  if ($[1] !== colourCls || $[2] !== icon) {
    t2 = /*#__PURE__*/_jsx(Icon, {
      className: colourCls,
      icon: icon,
      size: "small"
    });
    $[1] = colourCls;
    $[2] = icon;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== label) {
    t3 = /*#__PURE__*/_jsx(Text, {
      is: "span",
      colour: "dark",
      children: label
    });
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = /*#__PURE__*/_jsxs(Inline, {
      children: [t2, t3]
    });
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== onClick || $[10] !== t4) {
    t5 = /*#__PURE__*/_jsx(Box, {
      is: "button",
      className: styles.root,
      onClick: onClick,
      paddingX: "6",
      paddingY: "4",
      width: "full",
      alignItems: "center",
      backgroundColour: "white",
      display: "block",
      children: t4
    });
    $[9] = onClick;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
});